module.exports = __webpack_public_path__ + "img/sunnova.b602106c.svg";